import { useRef } from 'react';
import '../../assets/css/case-home.css';
import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
// @ts-ignore
import { useSlotGroup, EditableSlotGroup } from '@vibesites/runtime/react';
import { VibesitesImage } from '@vibesites/ui-primitives';

const NUM_SLOTS = 5;

function sliderSlotDef(index: number): SlotGroupDefinition {
  return {
    label: `Slider Image ${index + 1}`,
    fields: {
      image: {
        label: 'Image',
        type: 'image',
        defaultField: `photo_gallery[${index}].image`,
      },
      alt: {
        label: 'Alt Text',
        type: 'text',
        defaultField: `photo_gallery[${index}].alt_text`,
      },
    },
    sourceBinding: {
      collection: 'photo_gallery',
      defaultIndex: index,
      fieldMappings: { image: 'image', alt: 'alt_text' },
    },
  };
}

const SLOT_DEFS: Record<string, SlotGroupDefinition> = {};
for (let i = 0; i < NUM_SLOTS; i++) {
  SLOT_DEFS[`aboutimageslider.image_${i}`] = sliderSlotDef(i);
}

export function AboutImageSlider() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const slot0 = useSlotGroup('aboutimageslider.image_0', SLOT_DEFS['aboutimageslider.image_0']);
  const slot1 = useSlotGroup('aboutimageslider.image_1', SLOT_DEFS['aboutimageslider.image_1']);
  const slot2 = useSlotGroup('aboutimageslider.image_2', SLOT_DEFS['aboutimageslider.image_2']);
  const slot3 = useSlotGroup('aboutimageslider.image_3', SLOT_DEFS['aboutimageslider.image_3']);
  const slot4 = useSlotGroup('aboutimageslider.image_4', SLOT_DEFS['aboutimageslider.image_4']);

  return (
    <>
      <div className="case-aboutpage-spacer" aria-hidden="true" />
      <div className="case-aboutpage-slider">
        <div className="case-aboutpage-slider-track" ref={scrollRef}>
          <div className="case-aboutpage-slide">
            <EditableSlotGroup groupPath="aboutimageslider.image_0" definition={SLOT_DEFS['aboutimageslider.image_0']} style={{ height: '100%' }}>
              <VibesitesImage url={slot0.image} alt={slot0.alt || ''} width={352} height={391} />
            </EditableSlotGroup>
          </div>
          <div className="case-aboutpage-slide">
            <EditableSlotGroup groupPath="aboutimageslider.image_1" definition={SLOT_DEFS['aboutimageslider.image_1']} style={{ height: '100%' }}>
              <VibesitesImage url={slot1.image} alt={slot1.alt || ''} width={352} height={391} />
            </EditableSlotGroup>
          </div>
          <div className="case-aboutpage-slide">
            <EditableSlotGroup groupPath="aboutimageslider.image_2" definition={SLOT_DEFS['aboutimageslider.image_2']} style={{ height: '100%' }}>
              <VibesitesImage url={slot2.image} alt={slot2.alt || ''} width={352} height={391} />
            </EditableSlotGroup>
          </div>
          <div className="case-aboutpage-slide">
            <EditableSlotGroup groupPath="aboutimageslider.image_3" definition={SLOT_DEFS['aboutimageslider.image_3']} style={{ height: '100%' }}>
              <VibesitesImage url={slot3.image} alt={slot3.alt || ''} width={352} height={391} />
            </EditableSlotGroup>
          </div>
          <div className="case-aboutpage-slide">
            <EditableSlotGroup groupPath="aboutimageslider.image_4" definition={SLOT_DEFS['aboutimageslider.image_4']} style={{ height: '100%' }}>
              <VibesitesImage url={slot4.image} alt={slot4.alt || ''} width={352} height={391} />
            </EditableSlotGroup>
          </div>
        </div>
      </div>
    </>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'AboutImageSlider',
  displayName: 'About Image Slider',
  tokens: {},
  slotGroups: SLOT_DEFS,
};

(AboutImageSlider as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default AboutImageSlider;
